import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Box, Button, Flex } from '@chatterbug/aaron'

import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'

const ActivityWrapupCardWithAction = ({
  title,
  description,
  action,
  imageSection,
}) => {
  return (
    <PageWrapupCard>
      <Grid
        gridTemplateColumns={{
          _: '1fr',
          tablet: imageSection ? '1fr auto' : '1fr',
        }}
        gap="4x"
      >
        <Flex
          flexDirection="column"
          order={2}
          alignItems={{ _: 'stretch', tablet: 'flex-start' }}
        >
          <Box variant="text.h5">{title}</Box>
          <Box mt="1x" mb="3x" variant="text.paragraph" color="gray60">
            {description}
          </Box>
          {action && (
            <Button type="primaryAdvanced" fill="outline" href={action.href}>
              {action.label}
            </Button>
          )}
        </Flex>
        {imageSection && (
          <Box
            width={{ _: '100%', tablet: '253px' }}
            order={{ _: 1, tablet: 3 }}
          >
            {imageSection}
          </Box>
        )}
      </Grid>
    </PageWrapupCard>
  )
}

ActivityWrapupCardWithAction.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  }),
  imageSection: PropTypes.any,
}

export default ActivityWrapupCardWithAction
